// iter-65 #2 — Friendly production-type labels.
// Backend stores enum strings ("feature_film", "tv_single", "tv_series").
// Anywhere we render the value to the user, we pipe it through this helper
// so dashes/underscores never leak into the UI.

const LABELS = {
    feature_film: "Feature Film",
    tv_single: "Single TV Episode",
    tv_series: "Episodic TV Series",
};

export function productionTypeLabel(value) {
    if (!value) return "Production";
    if (LABELS[value]) return LABELS[value];
    // Soft fallback: humanise an unknown enum like "doc_series" → "Doc series".
    return value
        .split("_")
        .map((part) => (part ? part.charAt(0).toUpperCase() + part.slice(1) : ""))
        .join(" ")
        .trim();
}
